import React from "react"

import { Container, Copyright, Links, Link } from "./styles"

export default function Footer() {
  return (
    <Container>
      <Copyright>
        Todos os direitos reservado. Itaú. Porto Seguro - Porto Seguro Cia. de
        Seguros Gerais - Av. Rio Branco 1.489, Rua Guaianases 1.238, Campos
        Elíseos - CEP 01205-001
      </Copyright>
      <Links>
        <Link
          href="https://soscasaitau.portosegurofaz.com.br/politica"
          target="_blank"
        >
          Política de privacidade
        </Link>
        <Link
          href="https://soscasaitau.portosegurofaz.com.br/termos"
          target="_blank"
        >
          Termos de uso
        </Link>
        <Link
          href="https://soscasaitau.portosegurofaz.com.br/regulamento"
          target="_blank"
        >
          Regulamento
        </Link>
      </Links>
    </Container>
  )
}
